<template>
  <div class="text-left">
    Evaluation for <b>Simraan Kazi (APP20201212)</b> is completed the institution authorities will be in contact soon.
  </div>
</template>

<script>
export default {
  name: "ConfirmationStepperContent"
};
</script>

<style>
</style>